import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M8.001.583c-.215 0-.409.091-.546.236l-3.84 3.838a.75.75 0 0 0 1.06 1.06l2.576-2.573v8.19a.75.75 0 1 0 1.5 0V3.146l2.573 2.57a.75.75 0 1 0 1.06-1.06L8.576.85A.75.75 0 0 0 8 .583m-5.918 10.75a.75.75 0 0 0-1.5 0v1.834a2.25 2.25 0 0 0 2.25 2.25h10.334a2.25 2.25 0 0 0 2.25-2.25v-1.834a.75.75 0 0 0-1.5 0v1.834a.75.75 0 0 1-.75.75H2.833a.75.75 0 0 1-.75-.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }